import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconReportComponent } from "./med-icon-report.component";

@NgModule({
  declarations: [
    MedIconReportComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconReportComponent,
  ],
})
export class MedIconReportModule { }
